module.exports = __webpack_public_path__ + "static/media/typescript.8854b02a.svg";